module.exports = __webpack_public_path__ + "static/media/who-we-are-bg.410ba944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/who-we-are-bg.jpg
// module id = 1224
// module chunks = 0